import { render, staticRenderFns } from "./ovningsblad-dyn.vue?vue&type=template&id=2dc66e6c&scoped=true"
import script from "./ovningsblad-dyn.vue?vue&type=script&lang=js"
export * from "./ovningsblad-dyn.vue?vue&type=script&lang=js"
import style0 from "./ovningsblad-dyn.vue?vue&type=style&index=0&id=2dc66e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc66e6c",
  null
  
)

export default component.exports